const ar = {
  header: {
    acceuil: 'الرئيسية',
    aProposDuCentre: 'حول المركز',
    demandeSalle: 'حجز قاعة',
    nousContacter: 'اتصل بنا',
    lang: 'الإنجليزية',
    portail: 'مركز المحاكاة مراكش',
    portailOtherLang: 'M.T.C',
  },
  accueil: {
    landingTitle: 'مركز المحاكاة والابتكار في علوم الصحة',
    landingSubtitle: 'نوفّر بيئة تدريبية غامرة وواقعية باستخدام أحدث التقنيات والسيناريوهات السريرية المحاكية.',
    buttonLanding: 'معلومات عنا',
    procedure: 'الإجراءات',
    demandeReservationSalle: 'طلب حجز قاعة',
    suivreEtatDemande: 'متابعة حالة الطلب',
    confirmationDemande: 'تأكيد حضورك',
    commentSimulationPeutAider: 'كيف يمكن أن تساعدك المحاكاة؟',
    developpezCompetence: 'طوّر مهاراتك السريرية بأمان',
    experienceApprentissage: 'قدّم تجربة تعلم أكثر تفاعلية',
    encouragezInteractivite: 'شجّع التفاعل وروح الفريق',
  },
  aproposCentre: {
    aproposCentre: 'حول المركز:',
    aproposCentreContent: 'مرحبًا بكم في مركز المحاكاة والابتكار في علوم الصحة، وهو مكان مخصص للتميز في التدريب والبحث في مجال العلوم الصحية. يوفر المركز بيئة تدريبية غامرة وواقعية من خلال استخدام أحدث التقنيات والسيناريوهات السريرية المحاكية.',
    notreMission: 'مهمتنا:',
    notreMissionContent: 'مهمتنا هي تدريب المهنيين الصحيين في المستقبل عبر تزويدهم بالمهارات اللازمة لمواجهة تحديات العالم الحقيقي. نؤمن بأن الممارسة في بيئة آمنة وخاضعة للرقابة لا تحسّن المهارات التقنية فحسب، بل تعزز أيضًا التواصل والعمل الجماعي واتخاذ القرارات تحت الضغط.',
    nosInstallations: 'مرافقنا:',
    nosInstallationsItem1: 'محاكيات عالية الدقة: استخدام دمى متطورة تحاكي الظروف الفسيولوجية والمرضية الحقيقية.',
    nosInstallationsItem2: 'سيناريوهات غامرة: إنشاء سيناريوهات سريرية واقعية لتدريب عملي مكثف.',
    nosInstallationsItem3: 'تقنيات متقدمة: دمج الواقع الافتراضي والمعزز لتعزيز تجربة التعلم.',
    nosInstallationsItem4: 'مختبرات بحثية: دعم البحث المبتكر في تقنيات المحاكاة والتعليم الطبي.',
    revenirPageAccueil: 'العودة إلى الصفحة الرئيسية',
  },
  nousContacter: {
    nousContacter: 'اتصل بنا:',
    nomPrenom: 'الاسم الكامل',
    numeroTelephone: 'رقم الهاتف',
    objet: 'الموضوع',
    message: 'الرسالة',
    envoyer: 'إرسال',
    messageSuccess: 'تم إرسال رسالتك بنجاح',
  },
  reservationSalle: {
    demandeReservationSalle: 'طلب حجز قاعة',
    suivreEtatDemande: 'متابعة حالة الطلب',
    confirmationDemande: 'تأكيد الحضور',
    cin: 'رقم الهوية الوطنية',
    departement: 'القسم',
    nomPrenomFormateur: 'اسم المدرب',
    nomPrenomAssistantFormateur: 'اسم مساعد المدرب',
    programmeFormation: 'برنامج التدريب',
    materiel: 'المعدات التعليمية المطلوبة',
    consommables: 'المستهلكات',
    nombreParticipant: 'عدد المشاركين',
    typeApprentis: 'نوع المتدربين',
    typeApprentisItems: ['خارجي', 'أطباء مقيمون', 'أطباء داخليون'],
    choisirDateReservationSalle: 'اختر تاريخ حجز القاعة:',
    annee: 'السنة',
    mois: 'الشهر',
    moisItems: [
      'يناير', 'فبراير', 'مارس', 'أبريل', 'ماي', 'يونيو',
      'يوليو', 'أغسطس', 'سبتمبر', 'أكتوبر', 'نوفمبر', 'ديسمبر'
    ],
    confirmer: 'تأكيد',
    numeroDemande: 'رقم الطلب',
    consulterEtatDemande: 'التحقق من حالة الطلب',
    oublierNumeroDemandeInfo: 'إذا نسيت رقم طلبك، يرجى الاتصال بالفريق الإداري لمركز المحاكاة أو التواصل معنا عبر الصفحة المخصصة',
    faireAutreDemande: 'تقديم طلب حجز آخر',
    annulerDemande: 'إلغاء طلبي',
    confirmerPresence: 'تأكيد حضوري',
    successDemande: 'تم تسجيل طلبك بنجاح',
    votreDemandeNumero: 'رقم طلبك',
    enCoursTraitement: 'قيد المعالجة',
    rejete: 'تم رفضه.',
    information: '\nمعلومات: ',
    statutDialogTitle: 'رقم الطلب:',
    statutDialgoContent: 'يرجى حفظ هذا الرقم لتتمكن من متابعة طلبك لاحقًا',
    cinNumeroDemandeIncorrecte: 'رقم الهوية الوطنية أو رقم الطلب غير صحيح',
    votreDemandeReservationSalle: 'طلبك لحجز القاعة بتاريخ',
    demandeAccepted: 'تم قبوله، يرجى تأكيد حضورك',
    confirmationPresence: 'تأكيد الحضور:',
    annulationDemande: 'إلغاء الطلب:',
    presenceEnregistre: 'تم تسجيل حضورك بنجاح',
    demandeAnnule: 'تم إلغاء طلبك بنجاح',
    demandeCanceled: 'تم إلغاء هذا الطلب. يرجى إنشاء طلب جديد',
    inputError: 'يرجى تصحيح الأخطاء',
  },
  firstWorldCup: {
    jour: 'ي',
    heure: 'س',
    minute: 'د',
    seconde: 'ث',
    alaune: 'العناوين الرئيسية',
    worldcup: 'كأس العالم للمحاكاة الطبية للأطفال',
    dateWorldcup: 'من 03 إلى 06 يوليو 2025',
    firstEdition: 'الطبعة الأولى مراكش',
    enSavoirPlus: 'معرفة المزيد عن الحدث',
    participerEvent: 'المشاركة في الحدث',
    soumission: 'تقديم',
    inscription: 'التسجيل',
    inscriptionNotStudent: 'التسجيل (مقيم، أخصائي، شبه طبي)',
    inscriptionStudentSpectateur: 'مشاهد',
    typeParticipation: 'نوع المشاركة',
    typeParticipationItems: ['مشارك', 'مشاهد'],
    inscriptionStudentAttelier: 'ورشة عمل',
    inscriptionStudentCompetition: 'مسابقة',
    participerStudentEvent: 'المشاركة في الحدث كطالب',
    inscriptionStudent: 'التسجيل (طالب)',
    soumissionSuccess: 'تم إرسال مساهمتك بنجاح.',
    soumissionError: 'يرجى تصحيح الأخطاء',
    soumissionTitle: 'قدّم مساهمتك وشارك ابتكاراتك في المحاكاة الطبية:',
    titre: 'العنوان',
    auteur: 'المؤلف',
    coAuteur: 'المؤلف المشارك',
    typeSoumission: 'نوع التقديم',
    email: 'البريد الإلكتروني',
    specialite: 'التخصص',
    professionItems: ['طالب', 'مقيم', 'أخصائي', 'شبه طبي'],
    inscriptionContent: [
      'تم تسجيلك بنجاح!',
      'لقد أرسلنا لك بريدًا إلكترونيًا يحتوي على جميع المعلومات اللازمة لإتمام تسجيلك، بما في ذلك تفاصيل الدفع. يرجى التحقق من صندوق الوارد لديك (وربما مجلد البريد العشوائي) للوصول إلى هذه المعلومات.',
      'إذا كان لديك أي أسئلة أو واجهت أي صعوبات، لا تتردد في الاتصال بنا.',
      'شكرًا لك وإلى اللقاء قريبًا!'
    ],
    soumissionContent: [
      'تم استلام تقديمكم بنجاح!',
      'لقد أرسلنا لكم بريدًا إلكترونيًا يحتوي على جميع المعلومات اللازمة لإكمال تقديمكم، بما في ذلك تفاصيل الدفع. يرجى التحقق من صندوق الوارد (وربما مجلد البريد العشوائي) للوصول إلى هذه المعلومات.',
      'إذا كان لديكم أي أسئلة أو واجهتم أي صعوبات، فلا تترددوا في الاتصال بنا.',
      'شكرًا لكم وإلى اللقاء!'
    ],
    typeSoumissionItems: ['عرض شفهي', 'عرض ملصق', 'سيناريو'],
    accord: 'موافق',
    resume: 'الملخص',
    envoyer: 'إرسال',
    inscriptionError: 'يرجى تصحيح الأخطاء',
    inscriptionSuccess: 'تم إرسال تسجيلك بنجاح.',
    inscriptionTitle: 'سجل في المسابقة وأظهر مهاراتك في المحاكاة الطبية!',
    tel: 'رقم الهاتف',
    inscrir: 'التسجيل',
    titleEvent: 'أول كأس عالم للمحاكاة الطبية للأطفال',
    aproposEvent: 'حول الحدث',
    aproposContentEvent: 'شارك في أول كأس عالم للمحاكاة الطبية للأطفال! مسابقة فريدة تجمع أفضل المواهب في مجال المحاكاة الطبية للأطفال. لا تفوّت هذا الحدث الاستثنائي!',
    dateHeureEvent: 'تاريخ ووقت الحدث',
    dateHeureContentEvent: 'من 03 إلى 06 يوليو 2025',
    comiteOrganisationEvent: 'اللجنة المنظمة',
    comiteOrganisationContentEvent: 'الأستاذة نادية الإدريسي سلطن',
    programmeEvent: 'البرنامج',
    previousDay: 'اليوم السابق',
    nextDay: 'اليوم التالي',
    locationEvent: 'الموقع',
    locationContentEvent: 'كلية الطب والصيدلة بمراكش',
    messagePlusLimirWord: 'يجب ألا يتجاوز الملخص 500 كلمة.',
    telechargerAffiche: 'تحميل الملصق',
    pays: 'البلد',
    paysItems: ['المغرب', 'آخر'],
    ville: 'المدينة',
    nationalite: 'القارة',
    nationaliteItems: ['أفريقيا', 'أوروبا', 'أمريكا', 'آسيا'],
    profession: 'الفئة',
    nom1: 'الاسم الكامل لممثل الفريق',
    nom2: 'الاسم الكامل للمشارك الثاني',
    nom3: 'الاسم الكامل للمشارك الثالث',
    nom4: 'الاسم الكامل للمشارك الرابع',
    coach: 'الاسم الكامل للمدرب'
  },
  footer: {
    aProposDuCentre: 'حول المركز',
    reserverSalle: 'حجز قاعة',
    consulterEtatDemande: 'التحقق من حالة الطلب',
    nousContacter: 'اتصل بنا',
  },
};

export { ar };